import { getPath } from '@/router/common'

const baseUrl = {
  title: '展示图片',
  path: 'CheckImg'
}

export default [
  {
    path: getPath('ImgView', baseUrl),
    name: 'ImgView',
    component: () => import(/* webpackChunkName: "ImgView" */ '@/views/checkImg/imgView.vue'),
    meta: {
      title: '展示图片'
    }
  }
]
